import { render, staticRenderFns } from "./ListHousing.vue?vue&type=template&id=16c182cc&"
import script from "./ListHousing.vue?vue&type=script&lang=js&"
export * from "./ListHousing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports